import { Reveal } from "./Reveal";
import { CHAPTERS, IMAGES } from "../../data";

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative bg-[#050505] py-24 md:py-40"
  >
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.3em] text-[#e5ff00]">
              The Method
            </span>
            <h2 className="mt-5 font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9]">
              Four problems
              <br />
              <span className="text-outline">nobody else</span>
              <br />
              solves.
            </h2>
            <p className="mt-6 text-white/60 leading-relaxed max-w-sm">
              Generic coaches hand you a 9-to-5 plan and wish you luck. I build
              around the shift, the floor, and the after-hours reality.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="mt-10">
            <div className="relative overflow-hidden rounded-xl border border-white/10">
              <img
                src={IMAGES.bar}
                alt="Neon bar at night"
                className="w-full h-64 object-cover grayscale-[0.3] contrast-125"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <span className="absolute bottom-4 left-4 text-xs uppercase tracking-[0.25em] text-white/80">
                Your world at 2AM
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8 flex flex-col">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                data-testid={`chapter-${c.num}`}
                className="group flex flex-col md:flex-row gap-5 md:gap-10 py-8 md:py-10 border-t border-white/10 first:border-t-0 lg:first:border-t"
              >
                <div className="font-display text-6xl md:text-8xl text-outline group-hover:text-outline-neon transition-all duration-500 leading-none shrink-0">
                  {c.num}
                </div>
                <div className="md:pt-2">
                  <h3 className="font-display uppercase text-2xl md:text-3xl text-white group-hover:text-[#e5ff00] transition-colors duration-300">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-white/60 leading-relaxed max-w-xl">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
